{
  "mySystems": {
    "title": "Rendszereim",
    "description": "Szoftverrendszerek, amelyekért Ön felel és amelyeket kezel.",
    "empty": "Nem felel egyetlen szoftverrendszerért sem a szervezetében."
  },
  "systemLandscape": {
    "title": "Rendszertájkép",
    "view": {
      "list": "Lista",
      "2d": "2D",
      "3d": "3D"
    },
    "kpi": {
      "systems": "Rendszerek",
      "systemsDesc": "Összes aktív rendszer",
      "connections": "Kapcsolatok",
      "connectionsDesc": "Rendszer-rendszer közötti interakciók",
      "avgConnections": "Átl. kapcsolatok",
      "avgConnectionsDesc": "Rendszerenként",
      "isolated": "Izolált rendszerek",
      "isolatedDesc": "Kapcsolat nélküli rendszerek",
      "mediaBreaks": "Médiatörések",
      "mediaBreaksDesc": "Rendszerátmeneti törések"
    },
    "list": {
      "connections": "Kapcsolatok",
      "mediaBreaks": "Médiatörések"
    },
    "tooltip": {
      "upstream": "Fogad innen:",
      "downstream": "Küld ide:",
      "interactionCount": "{{count}} interakció"
    },
    "navInfo": "Bal kattintás: forgatás · Egérgörgő: nagyítás · Jobb kattintás: mozgatás"
  },
  "shadowSystems": {
    "title": "Árnyékrendszerek",
    "description": "Olyan szoftverek, amelyekre a munkatársak befejezett folyamatfelvételekben támaszkodnak, de amelyeket elutasítottak a hivatalos katalógusból – a láthatóvá tett árnyék-IT.",
    "search": "Árnyékrendszerek keresése...",
    "empty": "Nincsenek árnyékrendszerek – a befejezett felvételekben hivatkozott összes szoftver jóváhagyott.",
    "stats": {
      "shadowSystems": "Árnyékrendszerek",
      "recordingsAffected": "Érintett befejezett felvételek"
    },
    "columns": {
      "system": "Rendszer",
      "category": "Kategória",
      "url": "Link",
      "openLink": "Külső link megnyitása",
      "occurrences": "Előfordulások",
      "suggestedBy": "Javasolta",
      "submittedAt": "Javaslat dátuma",
      "reviewedBy": "Elutasította",
      "reviewedAt": "Elutasítás dátuma",
      "rejectionReason": "Elutasítás oka",
      "source": "Forrás"
    },
    "actions": {
      "resolve": "Feloldás",
      "resolved": "Árnyékrendszer feloldva"
    },
    "resolveDialog": {
      "title": "Árnyékrendszer feloldása",
      "description": "Leírás",
      "useExisting": "Összevonás meglévővel",
      "createNew": "Új rendszer létrehozása",
      "targetSystem": "Célrendszer",
      "selectSystem": "Válasszon rendszert",
      "name": "Név",
      "systemOwner": "Rendszer tulajdonos",
      "selectOwner": "Válasszon felelőst",
      "category": "Kategória",
      "url": "Hivatkozás"
    }
  }
}
